import { Observable } from "rxjs";
export function takeSync() {
    return (source) => new Observable((subscriber) => {
        const subscription = source.subscribe(subscriber);
        subscriber.complete();
        return subscription;
    });
}
//# sourceMappingURL=takeSync.js.map